import React, { Fragment } from 'react';
import T from 'prop-types';
import cx from 'classnames';

import { Menu, MenuItem, MenuButton, useMenuProps } from '../../../components/DropdownSet';
import Tooltip from '../../../components/Tooltip';

export const SECTIONS = [
  { id: 'market-overview', label: 'Market Overview', tooltip: 'Track the growth of DAUs and Downloads of the AI app market. See which apps are taking share.' },
  { id: 'behavioral-trends', label: 'Behavioral Trends', tooltip: 'Track AI user behaviors and quantify the impact of AI apps on non-AI sectors.' },
  { id: 'share-of-screen-time', label: 'Share of Screen Time', tooltip: 'Shows how much of total user attention AI apps capture compared to all other apps in thepanel.' },
  { id: 'market-behavior', label: 'AI User Segmentation', tooltip: 'Identifies key AI user types and tracks the flow of these users.' },
  { id: 'screen-time-by-sector', label: 'AI User Impact by Sector', tooltip: 'Highlights how time spent by medium and high-frequency AI users is changing across sectors and where their attention is concentrated.' },
  { id: 'app-trends', label: 'App Trends', tooltip: 'Explore engagement patterns for a selected AI app and how different segments interact with it.' },
  { id: 'ai-app-impact', label: 'AI App Impact', tooltip: 'Measures how AI adoption influences behavior across the broader app ecosystem.' },
];

const AiTabNavigation = ({ onScrollToSection }) => (
  <nav className="ai-tab-navigation">
    {SECTIONS.map((section, index) => (
      <Fragment key={section.id}>
        {index > 0 && <span className="ai-tab-navigation__separator">&middot;</span>}
        <Tooltip content={section.tooltip} placement="bottomLeft" colorVariant="light">
          <span className="ai-tab-navigation__link" onClick={() => onScrollToSection(section.id)}>
            {section.label}
          </span>
        </Tooltip>
      </Fragment>
    ))}
  </nav>
);

AiTabNavigation.propTypes = {
  onScrollToSection: T.func.isRequired,
};

export default AiTabNavigation;

export const AiTabNavigationDropdown = ({ active, onScrollToSection }) => {
  const menuProps = useMenuProps({ className: 'ai-sticky-header__menu' });

  if (!active) return null;

  return (
    <Menu
      menuButton={
        <MenuButton frameless className="ai-sticky-header__nav-btn">
          {active.label}
        </MenuButton>
      }
      {...menuProps}
    >
      {SECTIONS.map((section) => (
        <MenuItem
          key={section.id}
          className={cx('menu-item--14', {
            active: active.id === section.id,
          })}
          onClick={() => onScrollToSection(section.id)}
        >
          {section.label}
        </MenuItem>
      ))}
    </Menu>
  );
};

AiTabNavigationDropdown.propTypes = {
  active: T.shape({
    id: T.string.isRequired,
    label: T.string.isRequired,
  }),
  onScrollToSection: T.func.isRequired,
};
